import React from 'react';
import { Stack } from '@mui/material';
import CardLimite from "../CardLimite";
import { SistemaTipo } from "../../../types/enum/enum";
import {
    OperacionContraparteLimitesAprobadosPaisFields,
    OperacionContraparteLimitesSectorComercialFields
} from "../../sistema/sistemas/contraparte/types/fields";
import { OperacionContraparteLimitesAprobadosPais } from "../../sistema/sistemas/contraparte/types/dto";
import LimiteContraparteSectorComercial from './LimiteContraparteSectorComercial'; // Llama al componente de Sector

interface LimiteContraparteProps {
    data: OperacionContraparteLimitesAprobadosPais;
    loading?: boolean;
    error?: boolean;
}

function LimiteContraparte({ data, loading, error }: LimiteContraparteProps) {
    return (
        <Stack gap={1}>
            <CardLimite
                codSistema={SistemaTipo.Contrapartes}
                codPais={data[OperacionContraparteLimitesAprobadosPaisFields.CodPais]}
                pais={data[OperacionContraparteLimitesAprobadosPaisFields.NombrePais]}
            />

            {data[OperacionContraparteLimitesAprobadosPaisFields.ListaSectores].map((sector, index) => (
                <LimiteContraparteSectorComercial
                    key={`sector-header-${sector[OperacionContraparteLimitesSectorComercialFields.CodSectorComercial]}-${index}`}
                    data={sector}
                    loading={loading}
                    error={error}
                />
            ))}
        </Stack>
    );
}

export default LimiteContraparte;
